module.exports = __webpack_public_path__ + "static/media/diktat-31.d396c8c8.mp3";